import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Grid } from '@mui/material'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import enGB from 'date-fns/locale/en-GB'
import enDE from 'date-fns/locale/de'
import Import from '../../components/fs-file-upload/fs-pt-import'
import { ptAPI } from '../../shared/api/PTAPI'

const PtImportView = () => {
  const { t, i18n } = useTranslation()
  const [running, setRunning] = useState<boolean>(false)
  const [triggerSuccess, setTriggerSuccess] = useState<boolean | null>(null)
  const [startValue, setStartValue] = useState<Date | null>(null)

  const triggerAnalysis = () => {
    if (!startValue) {
      return
    }

    setRunning(true)
    ptAPI
      .triggerAnalysis(startValue)
      .then(() => {
        setTriggerSuccess(true)
        setRunning(false)
      })
      .catch(() => {
        setTriggerSuccess(false)
        setRunning(false)
      })
  }

  const defaultLocale = i18n.language === 'en' ? enGB : enDE

  return (
    <div>
      <h1>{t('import.data')}</h1>
      <Grid container mb={4}>
        <Grid size={{xs: 12, md: 8, lg: 6, xl: 4}}>
          <Import />
        </Grid>
      </Grid>
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={defaultLocale}>
        <DatePicker
          disableFuture
          label={t('start.date')}
          views={['year']}
          value={startValue}
          maxDate={new Date()}
          onChange={(newValue: any) => {
            if (newValue) {
              setStartValue(newValue)
            }
          }}
          slotProps={{
            field: {
              readOnly: true,
            },
          }}
        />
      </LocalizationProvider>
      <Button
        disabled={running || !startValue}
        variant="contained"
        sx={{ ml: 4 }}
        onClick={triggerAnalysis}
      >
        {running ? 'Analysing...' : 'Analyse'}
      </Button>
      {triggerSuccess === true ? <h4>Analysis trigger successful</h4> : null}
      {triggerSuccess === false ? <h4>Analysis trigger failed</h4> : null}
    </div>
  )
}

export default PtImportView
